// extracted by mini-css-extract-plugin
export default {"mCard":"OD-z","image":"PD-z","imageNoBackground":"QD-z","imageHasCategory":"RD-z","fullWidth":"SD-z"};